if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.product-media-modal__image-close')?.addEventListener('click', (event) => {
          event.preventDefault();
          this.hide();
        });
      }

      hide() {
        this.resetImageZoom();
        this.unbindImageZoom();
        this.unbindViewportPin();
        super.hide();
        this.unlockPageZoom();
      }

      show(opener) {
        this.scrollPosition = { x: window.scrollX, y: window.scrollY };
        this.lockPageZoom();
        super.show(opener);
        this.showActiveMedia();
        this.bindViewportPin();
        this.bindImageZoom();
      }

      lockPageZoom() {
        if ((window.visualViewport?.scale || 1) > 1 || this.lockedViewport != null) return;
        const meta = document.querySelector('meta[name="viewport"]');
        if (!meta) return;
        this.lockedViewport = meta.getAttribute('content');
        meta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
      }

      unlockPageZoom() {
        const meta = document.querySelector('meta[name="viewport"]');
        if (!meta || this.lockedViewport == null) return;
        meta.setAttribute('content', this.lockedViewport);
        this.lockedViewport = null;
        if (this.scrollPosition) window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
      }

      bindViewportPin() {
        this.unbindViewportPin();
        const toggle = this.querySelector('.product-media-modal__toggle');
        if (!toggle) return;

        const styles = getComputedStyle(toggle);
        this.toggleHome = {
          top: parseFloat(styles.top) || 0,
          left: parseFloat(styles.left) || 0,
        };
        this.onViewportChange = () => this.pinToggle();
        window.visualViewport?.addEventListener('scroll', this.onViewportChange);
        window.visualViewport?.addEventListener('resize', this.onViewportChange);
        this.pinToggle();
      }

      unbindViewportPin() {
        if (this.onViewportChange) {
          window.visualViewport?.removeEventListener('scroll', this.onViewportChange);
          window.visualViewport?.removeEventListener('resize', this.onViewportChange);
          this.onViewportChange = null;
        }
        this.querySelectorAll('.product-media-modal__toggle, .product-media-modal__image-close').forEach((button) => {
          button.style.top = '';
          button.style.left = '';
          button.style.right = '';
          button.style.transform = '';
          button.style.transformOrigin = '';
        });
      }

      pinToggle() {
        const toggle = this.querySelector('.product-media-modal__toggle');
        const viewport = window.visualViewport;
        if (!toggle || !viewport || !this.toggleHome) return;

        const scale = viewport.scale || 1;
        const inverse = 1 / scale;
        toggle.style.top = `${viewport.offsetTop + this.toggleHome.top * inverse}px`;
        toggle.style.left = `${viewport.offsetLeft + this.toggleHome.left * inverse}px`;
        toggle.style.transformOrigin = 'top left';
        toggle.style.transform = `scale(${inverse})`;
        this.pinImageClose(viewport, inverse);
      }

      pinImageClose(viewport, inverse) {
        const closeButton = this.querySelector('.product-media-modal__image-close');
        if (!closeButton) return;

        const inset = this.toggleHome.left;
        const layoutWidth = document.documentElement.clientWidth;
        closeButton.style.top = `${viewport.offsetTop + this.toggleHome.top * inverse}px`;
        closeButton.style.left = 'auto';
        closeButton.style.right = `${layoutWidth - viewport.offsetLeft - viewport.width + inset * inverse}px`;
        closeButton.style.transformOrigin = 'top right';
        closeButton.style.transform = `scale(${inverse})`;
      }

      bindImageZoom() {
        this.unbindImageZoom();
        this.zoom = { scale: 1, x: 0, y: 0, pinch: null };
        this.onZoomTouchStart = (event) => this.zoomTouchStart(event);
        this.onZoomTouchMove = (event) => this.zoomTouchMove(event);
        this.onZoomTouchEnd = () => this.zoomTouchEnd();
        this.onZoomWheel = (event) => this.zoomWheel(event);
        this.blockBrowserZoom = (event) => {
          if (event.type === 'wheel') {
            if (event.ctrlKey) event.preventDefault();
            return;
          }
          if (event.type === 'touchmove' && event.touches.length < 2) return;
          event.preventDefault();
        };

        const content = this.querySelector('.product-media-modal__content');
        content?.addEventListener('touchstart', this.onZoomTouchStart, { passive: true });
        content?.addEventListener('touchmove', this.onZoomTouchMove, { passive: false });
        content?.addEventListener('touchend', this.onZoomTouchEnd);
        content?.addEventListener('touchcancel', this.onZoomTouchEnd);
        content?.addEventListener('wheel', this.onZoomWheel, { passive: false });
        document.addEventListener('gesturestart', this.blockBrowserZoom, { passive: false });
        document.addEventListener('gesturechange', this.blockBrowserZoom, { passive: false });
        document.addEventListener('touchmove', this.blockBrowserZoom, { passive: false });
        document.addEventListener('wheel', this.blockBrowserZoom, { passive: false });
      }

      unbindImageZoom() {
        const content = this.querySelector('.product-media-modal__content');
        if (this.onZoomTouchStart) {
          content?.removeEventListener('touchstart', this.onZoomTouchStart);
          content?.removeEventListener('touchmove', this.onZoomTouchMove);
          content?.removeEventListener('touchend', this.onZoomTouchEnd);
          content?.removeEventListener('touchcancel', this.onZoomTouchEnd);
          content?.removeEventListener('wheel', this.onZoomWheel);
        }
        if (this.blockBrowserZoom) {
          document.removeEventListener('gesturestart', this.blockBrowserZoom);
          document.removeEventListener('gesturechange', this.blockBrowserZoom);
          document.removeEventListener('touchmove', this.blockBrowserZoom);
          document.removeEventListener('wheel', this.blockBrowserZoom);
          this.blockBrowserZoom = null;
        }
      }

      zoomTouchStart(event) {
        if (!this.zoom) return;
        if (event.touches.length === 2) {
          const mid = this.touchMidpoint(event.touches);
          this.zoom.pinch = {
            dist: this.touchDistance(event.touches),
            x: mid.x,
            y: mid.y,
            scale: this.zoom.scale,
            panX: this.zoom.x,
            panY: this.zoom.y,
          };
        } else if (event.touches.length === 1 && this.zoom.scale > 1) {
          this.zoom.pinch = {
            dist: 0,
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
            scale: this.zoom.scale,
            panX: this.zoom.x,
            panY: this.zoom.y,
          };
        }
      }

      zoomTouchMove(event) {
        if (!this.zoom?.pinch) return;
        if (event.touches.length === 2) {
          event.preventDefault();
          const dist = this.touchDistance(event.touches);
          const mid = this.touchMidpoint(event.touches);
          const pinch = this.zoom.pinch;
          if (!pinch.dist) return;
          this.zoom.scale = this.clampZoom(pinch.scale * (dist / pinch.dist));
          this.zoom.x = pinch.panX + (mid.x - pinch.x);
          this.zoom.y = pinch.panY + (mid.y - pinch.y);
          this.applyZoom();
        } else if (event.touches.length === 1 && this.zoom.scale > 1 && !this.zoom.pinch.dist) {
          event.preventDefault();
          const pinch = this.zoom.pinch;
          this.zoom.x = pinch.panX + (event.touches[0].clientX - pinch.x);
          this.zoom.y = pinch.panY + (event.touches[0].clientY - pinch.y);
          this.applyZoom();
        }
      }

      zoomTouchEnd() {
        if (!this.zoom) return;
        this.zoom.pinch = null;
        if (this.zoom.scale <= 1) {
          this.zoom.scale = 1;
          this.zoom.x = 0;
          this.zoom.y = 0;
          this.applyZoom();
        }
      }

      zoomWheel(event) {
        if (!event.ctrlKey || !this.zoom) return;
        event.preventDefault();
        const next = this.clampZoom(this.zoom.scale * Math.exp(-event.deltaY * 0.01));
        this.zoom.scale = next;
        if (next === 1) {
          this.zoom.x = 0;
          this.zoom.y = 0;
        }
        this.applyZoom();
      }

      clampZoom(scale) {
        return Math.min(4, Math.max(1, scale));
      }

      applyZoom() {
        const media = this.querySelector('.product-media-modal__content > .active');
        if (!media || !this.zoom) return;
        if (this.zoom.scale <= 1) {
          media.style.transform = '';
          return;
        }
        const maxX = (media.offsetWidth * (this.zoom.scale - 1)) / 2;
        const maxY = (media.offsetHeight * (this.zoom.scale - 1)) / 2;
        this.zoom.x = Math.min(maxX, Math.max(-maxX, this.zoom.x));
        this.zoom.y = Math.min(maxY, Math.max(-maxY, this.zoom.y));
        media.style.transformOrigin = 'center center';
        media.style.transform = `translate(${this.zoom.x}px, ${this.zoom.y}px) scale(${this.zoom.scale})`;
      }

      resetImageZoom() {
        this.querySelectorAll('.product-media-modal__content > .active').forEach((media) => {
          media.style.transform = '';
          media.style.transformOrigin = '';
        });
        this.zoom = { scale: 1, x: 0, y: 0, pinch: null };
      }

      touchDistance(touches) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.hypot(dx, dy);
      }

      touchMidpoint(touches) {
        return {
          x: (touches[0].clientX + touches[1].clientX) / 2,
          y: (touches[0].clientY + touches[1].clientY) / 2,
        };
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        container.scrollLeft = isMobile ? 0 : (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
